module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-window-information"
  }, [(_vm.orderWindowDate.startDate) ? _c('div', {
    staticClass: "infosOrderWindow infoStartDate"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.from")) + " : ")]), _vm._v(" " + _vm._s(_vm.orderWindowDate.startDate) + " (UTC)\n    ")]) : _vm._e(), _vm._v(" "), (_vm.orderWindowDate.endDate) ? _c('div', {
    staticClass: "infosOrderWindow infoEndDate"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.to")) + " : ")]), _vm._v(" " + _vm._s(_vm.orderWindowDate.endDate) + " (UTC)\n    ")]) : _vm._e(), _vm._v(" "), (_vm.orderWindowDate.terms && _vm.getTranslate(_vm.orderWindowDate.terms.description)) ? _c('div', {
    staticClass: "infosOrderWindow infoTerms"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.orderWindow.description")) + " : ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getTranslate(_vm.orderWindowDate.terms.description)))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64c4caaa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/summary-common/orderWindowInformation.vue
// module id = 3234
// module chunks = 0